import { ApiBase } from "../api-base";

interface TimestampContextPayload extends Record<string, unknown> {
    timezone: string | null;
    locale: string;
}

interface TimestampContextResponse {
    timezone?: string;
    locale?: string;
}

class TimestampApi extends ApiBase {
    public async syncClientContext(
        url: string,
        payload: TimestampContextPayload,
    ): Promise<TimestampContextResponse | null> {
        const response = await super.apiPost(url, payload, { noSpinner: true });
        return (await response.json().catch(() => null)) as TimestampContextResponse | null;
    }
}

export const timestampApi = new TimestampApi();
